<mat-form-field [appearance]="appearance" fxFlex *ngIf="!selectedForm">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.FORM' | translate }}</mat-label>
  <input
    [ngClass]="{ 'archived-selected': inputValue.value?.archived }"
    type="text"
    matInput
    [matAutocomplete]="auto"
    [(formControl)]="inputValue"
    [required]="required"
    [disabled]="disabled"
    placeholder="{{ 'MAINTENANCES.FORM_PLACEHOLDER' | translate }}"
    fxFlex="90"
  />
  <mat-autocomplete autoActiveFirstOption #auto="matAutocomplete" (optionSelected)="setSelectedForm()">
    <mat-progress-bar mode="indeterminate" *ngIf="loading"></mat-progress-bar>
    <mat-option *ngFor="let form of forms" [value]="form">
      <span [ngClass]="{ 'archived-selected': form.archived }">{{ form.name }}</span>
      <span class="archived-label" *ngIf="form.archived"> {{ 'MAINTENANCES.ARCHIVED' | translate }}</span>
    </mat-option>
    <mat-option *ngIf="!forms.length">
      {{ 'MAINTENANCES.FORM_NOT_FOUND' | translate }}
    </mat-option>
  </mat-autocomplete>
  <mat-error class="pb-4">
    <span *ngIf="inputValue.hasError('required')">{{ 'MAINTENANCES.FORM_REQUIRED' | translate }}</span>
  </mat-error>
</mat-form-field>

<mat-form-field [appearance]="appearance" fxFlex *ngIf="selectedForm">
  <mat-label *ngIf="floatLabel">{{ 'MAINTENANCES.FORM' | translate }}</mat-label>
  <input
    [ngClass]="{ 'archived-selected': selectedForm.archived }"
    type="text"
    matInput
    [value]="selectedForm.name"
    disabled
    required
  />
  <button
    [disabled]="disabled"
    mat-icon-button
    matSuffix
    fxFlex="10"
    class="form-cancel-button accent-700-fg"
    (click)="deselectForm()"
  >
    <mat-icon>cancel</mat-icon>
  </button>
</mat-form-field>
